const routeImporters = {
  home: () => import('../pages/Home'),
  explore: () => import('../pages/Explore'),
  campaignDetail: () => import('../pages/CampaignDetail'),
  guarantee: () => import('../pages/Guarantee'),
  paymentCallback: () => import('../pages/PaymentCallback'),
  about: () => import('../pages/Legal/About'),
  terms: () => import('../pages/Legal/Terms'),
  privacy: () => import('../pages/Legal/Privacy'),
  faq: () => import('../pages/Legal/Faq'),
  login: () => import('../pages/Auth/Login'),
  register: () => import('../pages/Auth/Register'),
  forgotPassword: () => import('../pages/Auth/ForgotPassword'),
  dashboard: () => import('../pages/Dashboard'),
  overview: () => import('../pages/Dashboard/Overview'),
  myCampaigns: () => import('../pages/Dashboard/MyCampaigns'),
  myContributions: () => import('../pages/Dashboard/MyContributions'),
  withdrawals: () => import('../pages/Dashboard/Withdrawals'),
  settings: () => import('../pages/Dashboard/Settings'),
  createCampaign: () => import('../pages/Dashboard/CreateCampaign'),
  editCampaign: () => import('../pages/Dashboard/EditCampaign'),
  admin: () => import('../pages/Admin'),
  adminDashboard: () => import('../pages/Admin/Dashboard'),
  adminCampaigns: () => import('../pages/Admin/Campaigns'),
  adminUsers: () => import('../pages/Admin/Users'),
  adminWithdrawals: () => import('../pages/Admin/Withdrawals'),
  adminReports: () => import('../pages/Admin/Reports'),
  notFound: () => import('../pages/NotFound'),
};

const prefetchedRoutes = new Set();

export function prefetchRoute(routeKey) {
  const loader = routeImporters[routeKey];
  if (!loader || prefetchedRoutes.has(routeKey)) return;

  prefetchedRoutes.add(routeKey);
  loader().catch(() => {
    // Keep runtime resilient; failed prefetch should not block navigation.
  });
}

export function prefetchRoutes(routeKeys = []) {
  routeKeys.forEach(prefetchRoute);
}

export function scheduleRoutePrefetch(routeKeys = [], timeout = 1500) {
  if (typeof window === 'undefined') return;

  const run = () => prefetchRoutes(routeKeys);
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(run, { timeout });
  } else {
    window.setTimeout(run, 300);
  }
}
